import { yup } from 'utils';

export const MachineSchema = yup.object().shape({
  lease_start_date: yup.string().required('リース期間を入力して下さい ').nullable(),
  lease_end_date: yup.string().required('リース期間を入力して下さい ').nullable(),
  lease_contract_date: yup.string().required('契約日を入力して下さい ').nullable(),
  lease_company: yup.string().required('リース会社を入力して下さい '),
  lease_shop: yup.string().required('販売店を入力して下さい '),
  lease_contract_id: yup.string().required('契約番号を入力して下さい '),
});

export const MachineSchemaChecked = yup.object().shape({
  lease_contract_date: yup.string().required('契約日を入力して下さい ').nullable(),
  lease_shop: yup.string().required('販売店を入力して下さい '),
  lease_contract_id: yup.string().required('契約番号を入力して下さい '),
});
